import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=48328fda&"
import script from "./changePassword.vue.ts?vue&type=script&lang=ts&"
export * from "./changePassword.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports